import { Controller } from 'stimulus'
import Cookies from 'js-cookie'

export default class extends Controller {
  connect() {
    if (!Cookies.get('gdpr_accept')) {
      this.show()
    }
  }

  accept() {
    Cookies.set('gdpr_accept', true, { expires: 365 })
    this.hide()
  }

  show() {
    this.element.classList.remove('hidden')
    this.element.removeAttribute('aria-hidden')
  }

  hide() {
    this.element.classList.add('hidden')
    this.element.setAttribute('aria-hidden', true)
  }
}
